import { render, staticRenderFns } from "./Screen3d.vue?vue&type=template&id=26c1b522&scoped=true&"
import script from "./Screen3d.vue?vue&type=script&lang=js&"
export * from "./Screen3d.vue?vue&type=script&lang=js&"
import style0 from "./Screen3d.vue?vue&type=style&index=0&id=26c1b522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c1b522",
  null
  
)

export default component.exports